import Vue from 'vue';
import VueRouter from 'vue-router';
import RockDashboard from '@/pages/RockDashboard';
import RockAdmin from '@/pages/RockAdmin';
import RockSettings from '@/pages/RockSettings';
// import RockSpaardoelen from '@/components/savingGoals/RockSavingGoals';

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        {
            path: '/',
            name: 'Dashboard',
            component: RockDashboard,
            meta: {
                roles: ['manager', 'employee']
            }
        },
        {
            path: '/admin',
            name: 'Admin',
            component: RockAdmin,
            meta: {
                roles: ['manager']
            }
        },
        {
            path: '/settings',
            name: 'Settings',
            component: RockSettings,
            meta: {
                roles: ['manager', 'employee']
            }
        }
        /*
        ,
        {
            path: '/spaardoelen',
            name: 'Spaardoelen',
            component: RockSpaardoelen,
            meta: {
                allowAdmin: false
            }
        }
        */
    ],
    mode: 'history',
    scrollBehavior: () => ({ y: 0 })
});

router.beforeEach((to, from, next) => {
    document.activeElement.blur();
    const { hasUserRole } = Vue.prototype.$keycloak;
    if (
        !to.matched.some((record) =>
            record.meta.roles.some((role) => hasUserRole(role))
        )
    ) {
        next('/');
    } else {
        next();
    }
});

export default router;
